import { render, staticRenderFns } from "./CompanyInfoSetting.vue?vue&type=template&id=a4bebaa4&"
import script from "./CompanyInfoSetting.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4bebaa4')) {
      api.createRecord('a4bebaa4', component.options)
    } else {
      api.reload('a4bebaa4', component.options)
    }
    module.hot.accept("./CompanyInfoSetting.vue?vue&type=template&id=a4bebaa4&", function () {
      api.rerender('a4bebaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/CompanyInfoSetting.vue"
export default component.exports